import { NAV_PATH } from '@/router/constants';
import { Link } from 'react-router';

const contentList = [
	{
		title: '거래처 상세 신용정보 관리',
		checkPoint: [
			'국내 최대 신용정보보유사인 <span class="font-bold">나이스평가정보</span>와의 제휴를 통해 다양한 기업정보 제공 <span class="color-primary">(업계 유일)</span> ',
			'약 900만 국내 기업에 대한 요약 정보 및  <span class="font-bold">경영진, 신용등급, 대표자정보, 재무정보</span> 등 제공',
			'국내기업 <span class="font-bold">신용평가 22단계 정보</span> 및 상세매출/자산/부채/자본 등 최신 주요 재무정보 제공'
		],
		img: 'img-box1'
	},
	{
		title: '삼일 Digital Transformation',
		checkPoint: [
			'Stella를 기반의 <span class="font-bold">맞춤형 자동화 프로그램 구축/컨설팅</span> (예: 맞춤형 BI 개발, 원가관리 플랫폼) ',
			'삼일 Digital Product 연계를 통한 <span class="font-bold">Digital Transformation</span> (예: 공시자동화 플랫폼)'
		],
		img: 'img-box2'
	},
	{
		title: '스타트업 통합경영지원서비스',
		checkPoint: [
			'국내 최대 회계법인의 스타트업 성장을 위한 <span class="font-bold">통합경영지원서비스</span> 제공',
			'Stella 기반 스타트업의 <span class="font-bold">결산,세무,급여 관리 서비스 제공</span>',
			'스타트업을 위한 <span class="font-bold">Virtual CFO 및 경영관리팀 역할 수행</span>'
		],
		img: 'img-box3'
	},
	{
		title: 'B2B',
		priceBox: `<p class="price-info">월 <span class="price">30,000</span>원<span class="vat">(VAT 별도)</span></p>
							<p class="detail-info">알림톡 500건 월 제공</p>
							<p class="promotion">3개월 무료 프로모션 진행중!</p>`,
		checkPoint: [
			'견적·발주·결제 등 기업 간 거래를 위한 B2B 서비스',
			'Stella에 등록된 품목·거래처 연동, 수주·출고 처리 연동, 결제관리 및 실시간 알림 제공'
		],
		link: `${NAV_PATH.FUNCTION.MAIN}#b2b`,
		img: 'img-box4'
		// highlightText: 'B2B 출시 기념 프로모션,&nbsp;<strong>3개월 무료!</strong> '
	},
	{
		title: '전자결재',
		priceBox: `<p class="price-info">월 <span class="price">50,000</span>원<span class="vat">(VAT 별도)</span></p>
							<p class="detail-info"><span style="color: #6B7684; font-size: 13px">‘한시적 적용’ &nbsp;</span> USER 무제한</p>
							<p class="promotion">가입월 무료 프로모션 진행중!</p>`,
		checkPoint: [
			'경비처리·회계전표 연동·업무관련 결재 상신에서 승인까지 가능한 전자결재 서비스',
			'ERP 연동으로 결재 이력 자동 동기화, 문서 관리 및 내부 통제 강화'
		],
		link: `${NAV_PATH.FUNCTION.MAIN}#e-approval`,
		img: 'img-box5'
		// highlightText: '전자결재 도입 기념 프로모션,&nbsp;<strong>가입월 무료!</strong>'
	},
	{
		title: '근태관리',
		priceBox: `<div class="price-info">월 <span class="price before">50,000</span>원 → <p class="discount">월 <span>30,000</span>원</p><span class="vat">(VAT 별도)</span></div>
							<p class="detail-info"><span style="color: #6B7684; font-size: 13px">‘한시적 적용’ &nbsp;</span> USER 무제한</p>
							<p class="promotion">신청월 무료 + 2만원 할인 프로모션 진행중!</p>`,
		checkPoint: [
			'휴가관리부터 급여 연동까지 지원하는 근태관리 서비스',
			'근무일정·인정근로시간 계산 및 ERP·전자결재 연동 지원'
		],
		link: `${NAV_PATH.FUNCTION.MAIN}#attd`,
		new: true,
		img: 'img-box6'
	},
	{
		title: '전자계약',
		priceBox: `<p class="price-info">건당 <span class="price">200</span>P</p>`,
		checkPoint: [
			'계약서 업로드부터 서명·보관까지 지원하는 전자계약 서비스',
			'서명 요청·진행상태 확인 및 감사추적 지원'
		],
		link: `${NAV_PATH.FUNCTION.MAIN}#e-contract`,
		new: true,
		img: 'img-box7'
	},
	{
		title: 'Accounting Insights',
		priceBox: `<p class="price-info">월 <span class="price">100,000</span>원<span class="vat">(VAT 별도)</span></p>
							<p class="detail-info">질의 30건 기본 제공</p>`,
		checkPoint: ['최신 회계기준서 기반 회계 기준 AI 챗봇', '전문적인 답변, 근거 문단, 관련 문서까지 한 번에 제공'],
		link: `${NAV_PATH.FUNCTION.CONVENIENCE}#account`,
		new: true,
		img: 'img-box8',
		highlightText: '삼일회계법인의 <strong>회계 AI</strong>를 스텔라 ERP에서 바로 사용하세요'
	}
];

const ThirdContent = () => {
	return (
		<section className="sub-content cont3">
			<div className="sub-inner">
				<strong className="title">스텔라만의 차별화 서비스</strong>
				<ul className="different-service">
					{contentList.map(({ title, img, new: isNew, priceBox, checkPoint, link, highlightText }) => (
						<li className="different-service-item" key={title}>
							<figure className={img} />

							<div className="cont-box">
								<div className="title">
									<p className={isNew ? 'new' : ''}>{title}</p>

									{priceBox && <div className="price-box" dangerouslySetInnerHTML={{ __html: priceBox }} />}
								</div>

								<ul className="check-point">
									{checkPoint.map(checkpoint => (
										<li key={checkpoint} dangerouslySetInnerHTML={{ __html: checkpoint }} />
									))}
								</ul>

								{highlightText && <span className="highlight" dangerouslySetInnerHTML={{ __html: highlightText }} />}

								{link && (
									<Link to={link} className="text-link">
										자세히보기
									</Link>
								)}
							</div>
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};

export default ThirdContent;
